export enum FieldType {
    NUMBER,
    BOOLEAN,
    SPLIT_SETBACK,
    NUMBER_NA
}
